import { StorefrontDto, StorefrontsClient } from "@lib/ShiOneClient";
import { STOREFRONTS_QUERY_KEY } from "@features/storefronts-feature/utils/constants";
import { useApi } from "@utils/useApi";
import { useQuery } from "@tanstack/react-query";
import ms from "ms";

export function useGetStorefronts(enabled = true) {
  const api = useApi(StorefrontsClient);

  return useQuery<StorefrontDto[]>({
    queryKey: [STOREFRONTS_QUERY_KEY],
    queryFn: async () => api.getStorefronts(),
    enabled,
    staleTime: ms("10m"),
  });
}